import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Button } from './Button';
export const Hero = () => {
  return <section className="relative pt-10 pb-12 md:pt-16 md:pb-24 overflow-hidden" data-id="element-78">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-79" />

      <div className="container relative z-10 px-4 mx-auto max-w-4xl text-center" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-81">
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 text-sm border rounded-full text-brand-gold border-brand-gold/30 bg-brand-gold/5" data-id="element-82">
            <Star className="w-4 h-4 fill-brand-gold" data-id="element-83" />
            <span data-id="element-84">4.9/5 Elegido por emprendedores</span>
          </div>

          <h1 className="mb-3 text-4xl font-bold leading-tight md:mb-4 md:text-6xl lg:text-7xl" data-id="element-85">
            Marketing <span className="text-gradient-gold" data-id="element-86">PRO</span>
          </h1>

          <h2 className="mb-6 text-xl font-semibold text-white md:mb-8 md:text-3xl font-serif" data-id="element-87">
            Lleva tu marca a las VENTAS ASEGURADAS
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mb-6 md:mb-8" data-id="element-88">
          <div className="relative mx-auto" style={{
          maxWidth: '320px'
        }} data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/3n8yLrWBf5LnRTXJFVZkXR/marketing_pro.png" alt="Marketing PRO Bundle" className="relative z-10 object-contain w-full h-auto drop-shadow-2xl" data-id="element-90" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-91">
          <p className="max-w-2xl mx-auto mb-6 text-base leading-relaxed text-gray-400 md:mb-8 md:text-xl" data-id="element-92">
            Recursos avanzados, plantillas, prompts y sistemas de contenido para
            dejar de publicar sin resultados y empezar a vender con estrategia.
          </p>

          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center" data-id="element-93">
            <Button href="#pricing" className="w-full sm:w-auto" data-id="element-94">
              Acceder a Marketing PRO ahora
            </Button>
            <p className="text-sm text-center text-gray-500" data-id="element-95">
              Garantía de 7 días • Acceso inmediato
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};